import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { fetchExeats } from '../../../../store/actions/exeatsActions'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import PlusIcon from '../../../../components/elements/icons/PlusIcon';
import ExeatsFilters from '../../../../components/elements/filters/ExeatsFilters';
import { authHeader, tableHeadersFields } from '../../../../utils';
import Loader from '../../../../components/elements/Loader';
import EmptyState from '../../../../components/elements/EmptyState';
import DataTable from '../../../../components/elements/DataTable';
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet';
import ExeatTypePill from '../../../../components/elements/ExeatTypePill';
import StatusPill from '../../../../components/elements/StatusPill';
import axios from 'axios';
import { ERROR } from '../../../../store/types';
import NewExeat from '../../../../components/partials/exeats/NewExeat';
import ModalDialog from '../../../../components/layouts/ModalDialog'
import ExeatCard from '../../../../components/partials/exeats/ExeatCard';

const Exeats = () => {
    const dispatch = useDispatch()
    const exeatsSelector = useSelector(state => state.exeats)

    const [page, setPage] = React.useState(1)
    const [perPage, setPerPage] = React.useState(25)
    const [filters, setFilters] = React.useState('')
    const [reload, setReload] = React.useState(0)
    const [currentTerm, setCurrentTerm] = React.useState(null)
    const [loading, setLoading] = React.useState(true)

    useEffect(() => {   
        const getCurrentTerm = async () => {
            try {
                const headers = authHeader()

                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/terms?currentlyActive=true`, { headers })
                console.log('terms response: ', response.data.data)        
                if(response.data.data.terms.length > 0) {
                    // const termId = response.data.data.terms[0]._id
                    
                    setCurrentTerm(response.data.data.terms[0])
                }

                setLoading(false)
                
            } catch (error) {
                console.error('error getting current term: ', error)
                dispatch({
                    type: ERROR,
                    error
                })
            }
        }
        getCurrentTerm()
        dispatch(fetchExeats(filters, page, perPage, reload))

    }, [dispatch, page, perPage, filters, reload]);

  const [creatingExeat, setCreatingExeat] = useState(false)

    const tableOptions = {
        selectable: true,
        multiselect: true,
        clickableRows: true,
        rowAction: (rowIndex)=>{
            openExeat(exeatsSelector.exeats?.exeats[rowIndex])
        }
    }
  
    const columnWidths = {
        student: 'w-2/12',
        reasonType: 'w-1/12',
        dates: 'w-2/12',
        pickup: 'w-2/12',
        status: 'w-2/12',
        approval: 'w-2/12',
        dateCreated: 'w-1/12'
    }
  
    const columnDataStyles = {}

    const cleanUpTableData = (array) => {
        if(!array) return
        let finalResult = [] 
        array.forEach((object, objectIndex) => {
            const staffObject = {
                student: <ApplicantTableSnippet applicant={object?.student} />,
                reasonType: <ExeatTypePill type={object.reasonType} />,
                dates: `${moment(object?.dates?.from).format('DD/MM/YYYY')} - ${moment(object?.dates?.to).format('DD/MM/YYYY')}`,
                pickup: <>By {object?.pickup?.name} ({object?.pickup?.phone}) <span className="block text-xs text-gray-500">at {moment(object?.pickup?.date).format('DD/MM/YYYY')}</span></>,
                status: <StatusPill status={object?.status} />,
                approval: <p><span className={`capitalize`}>{object?.approval?.status}</span> 
                {/* by {object?.approval?.statusChangedBy} */}
                </p>,
                dateCreated: object?.createdAt && moment(object?.createdAt).format('DD/MM/YYYY')
            }
    
            finalResult.push(staffObject)
      })
      return finalResult
    }

    const [activeExeat, setActiveExeat] = useState(null)
    const [viewingExeat, setViewingExeat] = useState(false)

    const openExeat = (exeat) => {
        setActiveExeat(exeat)
        setTimeout(() => {
            setViewingExeat(true)
        }, 200)
    }

    const closeExeat = () => {
        setViewingExeat(false)
        setTimeout(() => {
            setActiveExeat(null)
        }, 200)
    }

    return (
        <>
            <AdministrationLayout>
                <div className='w-full p-8'>
                    <div className="w-full mx-auto flex items-center justify-between">
                        <div className='w-8/12'>
                            <h4 className='font-medium text-lg mb-3 text-gray-400'>Exeats</h4>
                            <div className='w-2/3'>
                                <p className='text-gray-500 my-3 text-sm'>
                                    Below is a list of Exeats requested by parents and students at Vaatia College
                                </p>
                            </div>
                        </div>
                        <div className='w-4/12 flex flex-row-reverse'>
                            <button onClick={()=>{setCreatingExeat(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                <PlusIcon className='w-5 h-5' /> Create new Exeat
                            </button>
                        </div>
                    </div>
            
                    <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                        <div className='w-full'>
                            <ExeatsFilters applyFilters={(filters) => {
                                console.log('filters => ', filters)
                                setFilters(filters)
                            }} filtersToHide={[]} />
                        </div>
                        
                    </div>
            
                    {exeatsSelector?.loadingExeats || loading 
                    ? 
                        <Loader />
                    :
                        <>
                            {exeatsSelector?.exeats?.exeats?.length > 0 ? 
                                <div className=''>
                                {<div className='w-full'>
                                    <DataTable
                                        tableHeaders={tableHeadersFields(cleanUpTableData(exeatsSelector?.exeats?.exeats)[0]).headers} 
                                        tableData={cleanUpTableData(exeatsSelector?.exeats?.exeats)} 
                                        columnWidths={columnWidths}
                                        columnDataStyles={columnDataStyles}
                                        allFields={tableHeadersFields(cleanUpTableData(exeatsSelector?.exeats?.exeats)[0]).fields}
                                        onSelectItems={()=>{}}
                                        tableOptions={tableOptions}
                                        pagination={{
                                            perPage, 
                                            currentPage:page,
                                            totalItems: exeatsSelector.exeats.total,
                                        }}
                                        onSelectSingle={()=>{}}
                                        changePage={setPage}
                                        updatePerPage={setPerPage}
                                        
                                    />
                                </div>
                                }
                                </div>
                                : 
                                <div className='mt-24 w-1/2 mx-auto'>
                                    <EmptyState emptyStateText={`There are no exeats on this platform yet! You can create new exeats by clicking on "Create Exeat" above`} />
                                </div>
                
                            }
                        </>
                    }
                    </div>
            </AdministrationLayout>


            <ModalDialog
                shown={creatingExeat} 
                closeFunction={()=>{setCreatingExeat(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Create a new Exeat'
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <NewExeat 
                    term={currentTerm} 
                    reload={()=>{setReload(reload+1)}}
                    close={()=>{setCreatingExeat(false)}}
                />
            </ModalDialog>

            <ModalDialog
                shown={viewingExeat} 
                closeFunction={()=>{closeExeat()}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='ExeatDetails'
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <ExeatCard 
                    exeat={activeExeat} 
                    reload={()=>{setReload(reload+1)}}
                />
            </ModalDialog>
        </>
    )
}

export default Exeats